import type { ReactNode } from 'react';

/**
 * Morph timing shared by both platform shims — the outgoing content blurs +
 * fades away, then the incoming one blurs + fades in at the same spot (an
 * upload toast turning into its "uploaded" card). Out is shorter than in so
 * the swap reads as one beat, not two.
 */
export const TOAST_MORPH_OUT_MS = 160;
export const TOAST_MORPH_IN_MS = 280;
/** Peak defocus of the morphing content (web `blur(px)`; native maps it to an expo-blur intensity). */
export const TOAST_MORPH_BLUR_PX = 6;

export interface ToastContentMorphProps {
  /**
   * Identity of the content on screen. When it changes the current children
   * morph out and the new ones morph in; while it stays the same, children
   * update in place (a progress bar ticking).
   */
  morphKey: string;
  /** Layout classes for the wrapper (the toast's leading + text row). */
  className?: string;
  children: ReactNode;
}
